module.exports = __webpack_public_path__ + "img/DIENTEMALO.e514b1b2.png";